// Single source for contact details, calls to action and turnaround wording.
// Change wording here and it updates on every page that uses it.

export const practiceEmail = 'enquiries@medicolegal-psychiatry.co.uk'

export const callsToAction = {
  discussInstruction: {
    label: 'Discuss an Instruction',
    href: '/contact',
  },
  requestFeeQuote: {
    label: 'Request a Fee Quote',
    href: `mailto:${practiceEmail}?subject=${encodeURIComponent('Fee quote request')}`,
  },
}

export const turnaround = {
  urgent: 'Urgent enquiries: Dr Syed aims to respond within 1–2 days.',
  standard: 'Standard report turnaround: 5–7 working days.',
  caveat:
    'The 1–2 day figure is a response to an urgent enquiry, not a report delivery time. Report timing depends on the case, Dr Syed’s availability and receipt of complete instructions and records, and is confirmed before an instruction is accepted.',
}
